<template>
  <v-text-field v-model="inputValue" v-bind="$attrs" @change="handleChange" @blur="handleChange" />
</template>

<script>
export default {
  props: {
    value: null,
  },
  data() {
    return {
      inputValue: this.value || null,
    };
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        this.inputValue = value;
      },
    },
  },
  methods: {
    handleChange() {
      this.$emit('input', this.inputValue);
    },
  },
};
</script>
